import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LoginPage from "../pages/auth/login/page";
import RegisterPage from "../pages/auth/register/page";
import ResetPasswordPage from "../pages/auth/reset-password/page";
import RadioPage from "../pages/radio/page";
import RadioLivePage from "../pages/radio-live/page";
import AdminLayout from "@/layouts/AdminLayout";
import AdminDashboard from "../pages/admin/dashboard/page";
import AdminPosts from "../pages/admin/posts/page";
import AdminPhotos from "../pages/admin/photos/page";
import AdminVideos from "../pages/admin/videos/page";
import AdminLive from "../pages/admin/live/page";
import AdminCabina from "../pages/admin/cabina/page";
import AdminCabinaQueue from "../pages/admin/cabina/queue/page";
import AdminModeracion from "../pages/admin/cabina/moderacion/page";
import AdminSettings from "../pages/admin/settings/page";
import AdminSettingsCabina from "../pages/admin/settings/cabina/page";
import AdminSettingsCommunity from "../pages/admin/settings/community/page";
import AdminSettingsStream from "../pages/admin/settings/stream/page";
import AdminBroadcastCenter from "../pages/admin/broadcast-center/page";
import AdminSchedule from "../pages/admin/schedule/page";
import AdminContests from "../pages/admin/contests/page";
import AdminEvents from "../pages/admin/events/page";
import AdminAnalytics from "../pages/admin/analytics/page";
import AdminCommunityAnalytics from "../pages/admin/community-analytics/page";
import AdminCommunity from "../pages/admin/community/page";
import AdminCommunityConfig from "../pages/admin/community/config/page";
import AdminLiveChat from "../pages/admin/live-chat/page";
import AdminOnboarding from "../pages/admin/onboarding/page";
import AdminStaff from "../pages/admin/staff/page";
import AdminPrograms from "../pages/admin/programs/page";
import AdminSocialConnect from "../pages/admin/social-connect/page";
import AdminStorage from "../pages/admin/storage/page";
import NotificationsPage from "../pages/notifications/page";
import AdminNotifications from "../pages/admin/notifications/page";
import AdminSupport from "../pages/admin/support/page";
import AdminKnowledgeBase from "../pages/admin/knowledge-base/page";
import AdminExploreRadios from "../pages/admin/explore-radios/page";
import AdminPaymentProcessors from "../pages/admin/payment-processors/page";
import AdminAdditionalCharges from "../pages/admin/additional-charges/page";
import AdminQrPage from "../pages/admin/settings/qr/page";
import AdminDomainPage from "../pages/admin/settings/domain/page";
import AdminMonetization from "../pages/admin/monetization/page";
import AdminMonetizationConfig from "../pages/admin/monetization/config/page";
import AdminMonetizationAnalytics from "../pages/admin/monetization-analytics/page";
import AdminOwnAds from "../pages/admin/own-ads/page";
import AdminRfwNetwork from "../pages/admin/rfw-network/page";
import AdminMarketplace from "../pages/admin/marketplace/page";
import ProgramPage from "../pages/program/page";
import AppPage from "../pages/app/page";
import AppTrendingPage from "../pages/app-trending/page";
import AppLivePage from "../pages/app-live/page";
import AppSearchPage from "../pages/app-search/page";
import AppProfilePage from "../pages/app-profile/page";
import AppFavoritesPage from "../pages/app-favorites/page";
import AppSiguiendoPage from "../pages/app/siguiendo/page";
import AppChatPage from "../pages/app/chat/page";
import SaludosCancionesPage from "../pages/app/saludos-canciones/page";
import AppNotificacionesPage from "../pages/app/notificaciones/page";
import { TvPairingProvider } from "@/context/TvPairingContext";
import TvAppPage from "../pages/tv-app/page";
import TvPlayerPage from "../pages/tv-app/player/page";
import TvVideoPage from "../pages/tv-app/video/page";
import TvPodcastPage from "../pages/tv-app/podcast/page";
import TvQrPage from "../pages/tv-app/qr/page";
import TvRemotePage from "../pages/tv-app/remote/page";
import TvRadioProfilePage from "../pages/tv-app/radio/page";
import TvProgramDetailPage from "../pages/tv-app/program/page";
import TvHostDetailPage from "../pages/tv-app/host/page";
import TvEventDetailPage from "../pages/tv-app/event/page";
import TvContestDetailPage from "../pages/tv-app/contest/page";
import SuperAdminDashboard from "../pages/sa/dashboard/page";
import SuperAdminRadios from "../pages/sa/radios/page";
import SuperAdminFrequencies from "../pages/sa/frequencies/page";
import SuperAdminAds from "../pages/sa/ads/page";
import SAMarketplace from "../pages/sa/ad-marketplace/page";
import SARevenueShare from "../pages/sa/revenue-share/page";
import SuperAdminPlans from "../pages/sa/plans/page";
import SAFeesCharges from "../pages/sa/fees-charges/page";
import SuperAdminAnalytics from "../pages/sa/analytics/page";
import SuperAdminRadioHealth from "../pages/sa/radio-health/page";
import SuperAdminReports from "../pages/sa/reports/page";
import SuperAdminRadioApprovals from "../pages/sa/radio-approvals/page";
import SuperAdminStorage from "../pages/sa/storage/page";
import SuperAdminSocialStatus from "../pages/sa/social-status/page";
import SuperAdminSystemHealth from "../pages/sa/system-health/page";
import SuperAdminBilling from "../pages/sa/billing/page";
import SuperAdminPayments from "../pages/sa/payments/page";
import SuperAdminInvoices from "../pages/sa/invoices/page";
import SuperAdminPaymentProcessors from "../pages/sa/payment-processors/page";
import SuperAdminAdditionalCharges from "../pages/sa/additional-charges/page";
import SuperAdminMarketing from "../pages/sa/marketing/page";
import SuperAdminBroadcastMessages from "../pages/sa/broadcast-messages/page";
import SuperAdminBroadcastCenter from "../pages/sa/broadcast-center/page";
import SuperAdminNotifications from "../pages/sa/notifications/page";
import SuperAdminApps from "../pages/sa/apps/page";
import SuperAdminLiveSupport from "../pages/sa/live-support/page";
import SuperAdminAIAssistant from "../pages/sa/ai-assistant/page";
import SuperAdminAuditLog from "../pages/sa/audit-log/page";
import SuperAdminSupport from "../pages/sa/support/page";
import SuperAdminSettings from "../pages/sa/settings/page";
import SASettingsAppsPage from "../pages/sa/settings-apps/page";
import SuperAdminEmailTemplates from "../pages/sa/email-templates/page";
import SuperAdminContracts from "../pages/sa/contracts/page";
import SuperAdminLegalTemplates from "../pages/sa/legal-templates/page";
import SuperAdminPlatformFees from "../pages/sa/platform-fees/page";
import SuperAdminBillingRenewals from "../pages/sa/billing-renewals/page";
import SuperAdminAnnualLicense from "../pages/sa/annual-license/page";
import SASponsors from "../pages/sa/sponsors/page";
import SACommunityCenter from "../pages/sa/community-center/page";
import SAGlobalModeration from "../pages/sa/global-moderation/page";
import SAAIRadio from "../pages/sa/ai-radio/page";
import SAGrowthCenter from "../pages/sa/growth-center/page";
import SARadioQrPage from "../pages/sa/radios/qr/page";
import SARadioDomainPage from "../pages/sa/radios/domain/page";
import SuperAdminPremiumDomains from "../pages/sa/premium-domains/page";
import SAPermanentQr from "../pages/sa/permanent-qr/page";
import SuperAdminLegalCenter from "../pages/sa/legal-center/page";
import SAAdNetwork from "../pages/sa/ad-network/page";
import SAAdSpaces from "../pages/sa/ad-spaces/page";
import SAOwnAds from "../pages/sa/own-ads/page";
import SARfwCampaigns from "../pages/sa/rfw-campaigns/page";
import SARadioAdvertiser from "../pages/sa/radio-advertiser/page";
import SACommercialMarketplace from "../pages/sa/commercial-marketplace/page";
import SAMonetizationAudit from "../pages/sa/monetization-audit/page";
import SACampaigns from "../pages/sa/campaigns/page";
import SAAdvertisers from "../pages/sa/advertisers/page";
import SAMarketplaceUnified from "../pages/sa/marketplace/page";
import SABroadcasters from "../pages/sa/broadcasters/page";
import SAPrograms from "../pages/sa/programs/page";
import SATopFans from "../pages/sa/top-fans/page";
import SAListenerTiers from "../pages/sa/listener-tiers/page";
import SAListenerMap from "../pages/sa/listener-map/page";
import SALiveRadios from "../pages/sa/live-radios/page";
import SATrending from "../pages/sa/trending/page";
import SAVipClubs from "../pages/sa/vip-clubs/page";
import SAUsersManagement from "../pages/sa/users/page";
import SAIntegrationsCenter from "../pages/sa/integrations/page";
import SAFeatureFlagsManager from "../pages/sa/feature-flags/page";
import SALicensingCenter from "../pages/sa/licensing/page";
import SAGlobalConfigCenter from "../pages/sa/global-config/page";
import SAGlobalAuditCenter from "../pages/sa/global-audit-center/page";
import SASecurityCenter from "../pages/sa/security/page";
import SASystemHealthCenter from "../pages/sa/system-health-center/page";
import SAGlobalNotificationCenter from "../pages/sa/global-notification-center/page";
import SAGlobalBackupCenter from "../pages/sa/global-backup-center/page";
import SAGlobalMaintenanceCenter from "../pages/sa/global-maintenance-center/page";
import SARolesPermissions from "../pages/sa/roles-permissions/page";
import SAPayouts from "../pages/sa/payouts/page";
import SAEconomy from "../pages/sa/economy/page";
import SAVerification from "../pages/sa/verification/page";
import SASocialAudit from "../pages/sa/social-audit/page";
import LegalCenterPage from "../pages/legal-center/page";
import PublicSignContract from "../pages/sign-contract/page";
import ListenerCenter from "../pages/listener/page";
import ExplorePage from "../pages/explore/page";
import SearchPage from "../pages/search/page";
import PricingPage from "../pages/pricing/page";
import RegisterRadioPage from "../pages/register-radio/page";
import ApplicationStatusPage from "../pages/radio-application-status/page";
import RadioOfflinePage from "../pages/radio-offline/page";
import EventsPage from "../pages/events/page";
import RadiosPage from "../pages/radios/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import RadioRulesPage from "../pages/radio-rules/page";
import RankingsPage from "../pages/rankings/page";
import PublicPhotos from "../pages/photos/page";
import PublicVideos from "../pages/videos/page";
import AdminCabinaSettings from "../pages/admin/cabina/settings/page";
import AdminStudio from "../pages/admin/studio/page";
import AdminGreetings from "../pages/admin/greetings/page";
import AdminSongRequests from "../pages/admin/song-requests/page";
import RedirectPage from "../pages/redirect/page";
import CookiesPage from "../pages/cookies/page";
import DownloadAppPage from "../pages/download-app/page";
import AdminChatComunidad from "../pages/admin/chat/page";
import AdminHosts from "../pages/admin/hosts/page";
import AdminProfile from "../pages/admin/profile/page";
import OyenteProfile from "../pages/oyente/page";
import GamificacionPage from "../pages/gamificacion/page";
import NivelesPage from "../pages/niveles/page";
import InsigniasPage from "../pages/insignias/page";
import FavoritosPage from "../pages/favoritos/page";
import HistorialPage from "../pages/historial/page";
import TopFansPage from "../pages/top-fans/page";
import ClubVipPage from "../pages/club-vip/page";
import ClubesPage from "../pages/clubes/page";
import CompetenciasPage from "../pages/competencias/page";
import CentroSocialPage from "../pages/centro-social/page";
import HostPage from "../pages/host/page";
import DiscoveryPage from "../pages/discovery/page";
import LiveRadiosPage from "../pages/live/page";
import ProgramsLivePage from "../pages/programs-live/page";
import HostsLivePage from "../pages/hosts-live/page";
import GamificationCenterPage from "../pages/gamification-center/page";
import WorldMapPage from "../pages/world-map/page";
import PublicidadPage from "../pages/publicidad/page";
import GanadoresPage from "../pages/ganadores/page";
import PatrocinadoresPage from "../pages/patrocinadores/page";
import CopasPage from "../pages/copas/page";
import EncuestasPage from "../pages/encuestas/page";
import TriviasPage from "../pages/trivias/page";
import SeguidoresPage from "../pages/seguidores/page";
import CompartidosPage from "../pages/compartidos/page";
import MapaRfwPage from "../pages/mapa-rfw/page";
import LogrosPage from "../pages/logros/page";
import EmbajadoresPage from "../pages/embajadores/page";
import RetosClubesPage from "../pages/retos-clubes/page";
import VipRfwPage from "../pages/vip-rfw/page";
import ReaccionesPage from "../pages/reacciones/page";
import GuardadosPage from "../pages/guardados/page";
import CentroNotificacionesPage from "../pages/centro-notificaciones/page";
import PerfilSocialOyentePage from "../pages/perfil-social-oyente/page";
import SeguirUsuariosPage from "../pages/seguir-usuarios/page";
import MensajesPrivadosPage from "../pages/mensajes-privados/page";
import ModeradoresPage from "../pages/moderadores/page";
import ReportesPage from "../pages/reportes/page";
import VerificacionPage from "../pages/verificacion/page";
import AchievementsEnVivoPage from "../pages/achievements-en-vivo/page";
import RachasPage from "../pages/rachas/page";
import AniversariosPage from "../pages/aniversarios/page";
import BienvenidaPage from "../pages/bienvenida/page";
import ActividadGlobalPage from "../pages/actividad-global/page";
import CanalRFWPage from "../pages/canal-rfw/page";
import OnboardingRadiosPage from "../pages/onboarding-radios/page";
import DashboardSimplePage from "../pages/dashboard-simple/page";
import CentroTransmisionPage from "../pages/centro-transmision/page";
import ProgramacionAutomaticaPage from "../pages/programacion-automatica/page";
import SistemaLocutoresPage from "../pages/sistema-locutores/page";
import SistemaProgramasPage from "../pages/sistema-programas/page";
import Cabina2Page from "../pages/cabina-2/page";
import CancionesSolicitadasPage from "../pages/canciones-solicitadas/page";
import SistemaSaludosPage from "../pages/sistema-saludos/page";
import AudioMensajesPage from "../pages/audio-mensajes/page";
import ClipsPage from "../pages/clips/page";
import TendenciasEnVivoPage from "../pages/tendencias-en-vivo/page";
import RadiosVerificadasPage from "../pages/radios-verificadas/page";
import RadiosCercanasPage from "../pages/radios-cercanas/page";
import SistemaDescubrimientoPage from "../pages/sistema-descubrimiento/page";
import PatrocinadoresLocalesPage from "../pages/patrocinadores-locales/page";
import Top10GlobalPage from "../pages/top-10-global/page";
import Top10CategoriaPage from "../pages/top-10-categoria/page";
import Top10PaisPage from "../pages/top-10-pais/page";
import ChannelPlayerPage from "../modules/player/pages/ChannelPlayerPage";
import SuperAdminRadioAnalytics from "../pages/sa/radio-analytics/page";
import SuperAdminCommunityAnalytics from "../pages/sa/community-analytics/page";
import SuperAdminRevenueAnalytics from "../pages/sa/monetization-analytics/page";
import SAMaintenanceCenter from "../pages/sa/maintenance-center/page";
import SAReleases from "../pages/sa/releases/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
  },
  {
    path: "/descubrir",
    element: <DiscoveryPage />,
  },
  {
    path: "/radios-en-vivo",
    element: <LiveRadiosPage />,
  },
  {
    path: "/programas-en-vivo",
    element: <ProgramsLivePage />,
  },
  {
    path: "/locutores-en-vivo",
    element: <HostsLivePage />,
  },
  {
    path: "/mapa-mundial",
    element: <WorldMapPage />,
  },
  {
    path: "/centro-gamificacion",
    element: <GamificationCenterPage />,
  },
  {
    path: "/buscar",
    element: <SearchPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/register-radio",
    element: <RegisterRadioPage />,
  },
  {
    path: "/radio-application-status",
    element: <ApplicationStatusPage />,
  },
  {
    path: "/radio-offline",
    element: <RadioOfflinePage />,
  },
  {
    path: "/radios",
    element: <RadiosPage />,
  },
  {
    path: "/events",
    element: <EventsPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/cookies",
    element: <CookiesPage />,
  },
  {
    path: "/descargar",
    element: <DownloadAppPage />,
  },
  {
    path: "/radio-rules",
    element: <RadioRulesPage />,
  },
  {
    path: "/rankings",
    element: <RankingsPage />,
  },
  {
    path: "/notifications",
    element: <NotificationsPage />,
  },
  {
    path: "/photos",
    element: <PublicPhotos />,
  },
  {
    path: "/videos",
    element: <PublicVideos />,
  },
  {
    path: "/listener",
    element: <ListenerCenter />,
  },
  {
    path: "/oyente",
    element: <OyenteProfile />,
  },
  {
    path: "/gamificacion",
    element: <GamificacionPage />,
  },
  {
    path: "/niveles",
    element: <NivelesPage />,
  },
  {
    path: "/insignias",
    element: <InsigniasPage />,
  },
  {
    path: "/favoritos",
    element: <FavoritosPage />,
  },
  {
    path: "/historial",
    element: <HistorialPage />,
  },
  {
    path: "/top-fans",
    element: <TopFansPage />,
  },
  {
    path: "/club-vip",
    element: <ClubVipPage />,
  },
  {
    path: "/clubes",
    element: <ClubesPage />,
  },
  {
    path: "/competencias",
    element: <CompetenciasPage />,
  },
  {
    path: "/publicidad",
    element: <PublicidadPage />,
  },
  {
    path: "/ganadores",
    element: <GanadoresPage />,
  },
  {
    path: "/patrocinadores",
    element: <PatrocinadoresPage />,
  },
  {
    path: "/copas",
    element: <CopasPage />,
  },
  {
    path: "/eventos",
    element: <Navigate to="/events" replace />,
  },
  {
    path: "/encuestas",
    element: <EncuestasPage />,
  },
  {
    path: "/trivias",
    element: <TriviasPage />,
  },
  {
    path: "/seguidores",
    element: <SeguidoresPage />,
  },
  {
    path: "/compartidos",
    element: <CompartidosPage />,
  },
  {
    path: "/mapa-rfw",
    element: <MapaRfwPage />,
  },
  {
    path: "/logros",
    element: <LogrosPage />,
  },
  {
    path: "/embajadores",
    element: <EmbajadoresPage />,
  },
  {
    path: "/retos-clubes",
    element: <RetosClubesPage />,
  },
  {
    path: "/vip-rfw",
    element: <VipRfwPage />,
  },
  {
    path: "/reacciones",
    element: <ReaccionesPage />,
  },
  {
    path: "/guardados",
    element: <GuardadosPage />,
  },
  {
    path: "/centro-notificaciones",
    element: <CentroNotificacionesPage />,
  },
  {
    path: "/perfil-social-oyente",
    element: <PerfilSocialOyentePage />,
  },
  {
    path: "/seguir-usuarios",
    element: <SeguirUsuariosPage />,
  },
  {
    path: "/explorar",
    element: <ExplorePage />,
  },
  {
    path: "/centro-social",
    element: <CentroSocialPage />,
  },
  {
    path: "/mensajes-privados",
    element: <MensajesPrivadosPage />,
  },
  {
    path: "/moderadores",
    element: <ModeradoresPage />,
  },
  {
    path: "/reportes",
    element: <ReportesPage />,
  },
  {
    path: "/verificacion",
    element: <VerificacionPage />,
  },
  {
    path: "/achievements-en-vivo",
    element: <AchievementsEnVivoPage />,
  },
  {
    path: "/rachas",
    element: <RachasPage />,
  },
  {
    path: "/aniversarios",
    element: <AniversariosPage />,
  },
  {
    path: "/bienvenida",
    element: <BienvenidaPage />,
  },
  {
    path: "/actividad-global",
    element: <ActividadGlobalPage />,
  },
  {
    path: "/canal-rfw",
    element: <CanalRFWPage />,
  },
  {
    path: "/onboarding-radios",
    element: <OnboardingRadiosPage />,
  },
  {
    path: "/dashboard-simple",
    element: <DashboardSimplePage />,
  },
  {
    path: "/centro-transmision",
    element: <CentroTransmisionPage />,
  },
  {
    path: "/programacion-automatica",
    element: <ProgramacionAutomaticaPage />,
  },
  {
    path: "/sistema-locutores",
    element: <SistemaLocutoresPage />,
  },
  {
    path: "/sistema-programas",
    element: <SistemaProgramasPage />,
  },
  {
    path: "/cabina-2",
    element: <Cabina2Page />,
  },
  {
    path: "/canciones-solicitadas",
    element: <CancionesSolicitadasPage />,
  },
  {
    path: "/sistema-saludos",
    element: <SistemaSaludosPage />,
  },
  {
    path: "/audio-mensajes",
    element: <AudioMensajesPage />,
  },
  {
    path: "/eventos-en-vivo",
    element: <Navigate to="/events" replace />,
  },
  {
    path: "/clips",
    element: <ClipsPage />,
  },
  {
    path: "/tendencias-en-vivo",
    element: <TendenciasEnVivoPage />,
  },
  {
    path: "/radios-verificadas",
    element: <RadiosVerificadasPage />,
  },
  {
    path: "/radios-cercanas",
    element: <RadiosCercanasPage />,
  },
  {
    path: "/sistema-descubrimiento",
    element: <SistemaDescubrimientoPage />,
  },
  {
    path: "/patrocinadores-locales",
    element: <PatrocinadoresLocalesPage />,
  },
  {
    path: "/top-10-global",
    element: <Top10GlobalPage />,
  },
  {
    path: "/top-10-categoria",
    element: <Top10CategoriaPage />,
  },
  {
    path: "/top-10-pais",
    element: <Top10PaisPage />,
  },
  {
    path: "/radio/:frequency/live",
    element: <RadioLivePage />,
  },
  {
    path: "/radio/:frequency",
    element: <RadioPage />,
  },
  {
    path: "/host/:slug",
    element: <HostPage />,
  },
  {
    path: "/r/:code",
    element: <RedirectPage />,
  },
  {
    path: "/admin",
    element: <AdminLayout />,
    children: [
      {
        path: "dashboard",
        element: <AdminDashboard />,
      },
      {
        path: "posts",
        element: <AdminPosts />,
      },
      {
        path: "photos",
        element: <AdminPhotos />,
      },
      {
        path: "videos",
        element: <AdminVideos />,
      },
      {
        path: "broadcast-center",
        element: <AdminBroadcastCenter />,
      },
      {
        path: "live",
        element: <AdminLive />,
      },
      {
        path: "cabina",
        element: <AdminCabina />,
      },
      {
        path: "cabina/moderacion",
        element: <AdminModeracion />,
      },
      {
        path: "cabina/queue",
        element: <AdminCabinaQueue />,
      },
      {
        path: "cabina/messages",
        element: <Navigate to="/admin/cabina" replace />,
      },
      {
        path: "cabina/settings",
        element: <AdminCabinaSettings />,
      },
      {
        path: "studio",
        element: <AdminStudio />,
      },
      {
        path: "greetings",
        element: <AdminGreetings />,
      },
      {
        path: "song-requests",
        element: <AdminSongRequests />,
      },
      {
        path: "settings",
        element: <AdminSettings />,
      },
      {
        path: "settings/cabina",
        element: <AdminSettingsCabina />,
      },
      {
        path: "settings/community",
        element: <AdminSettingsCommunity />,
      },
      {
        path: "settings/stream",
        element: <AdminSettingsStream />,
      },
      {
        path: "settings/qr",
        element: <AdminQrPage />,
      },
      {
        path: "settings/domain",
        element: <AdminDomainPage />,
      },
      {
        path: "schedule",
        element: <AdminSchedule />,
      },
      {
        path: "contests",
        element: <AdminContests />,
      },
      {
        path: "events",
        element: <AdminEvents />,
      },
      {
        path: "analytics",
        element: <AdminAnalytics />,
      },
      {
        path: "community-analytics",
        element: <AdminCommunityAnalytics />,
      },
      {
        path: "monetization",
        element: <AdminMonetization />,
      },
      {
        path: "monetization/config",
        element: <AdminMonetizationConfig />,
      },
      {
        path: "monetization-analytics",
        element: <AdminMonetizationAnalytics />,
      },
      {
        path: "own-ads",
        element: <AdminOwnAds />,
      },
      {
        path: "rfw-network",
        element: <AdminRfwNetwork />,
      },
      {
        path: "marketplace",
        element: <AdminMarketplace />,
      },
      {
        path: "community",
        element: <AdminCommunity />,
      },
      {
        path: "community/config",
        element: <AdminCommunityConfig />,
      },
      {
        path: "unified-chat",
        element: <Navigate to="/admin/live-chat" replace />,
      },
      {
        path: "live-chat",
        element: <AdminLiveChat />,
      },
      {
        path: "chat",
        element: <AdminChatComunidad />,
      },
      {
        path: "hosts",
        element: <AdminHosts />,
      },
      {
        path: "onboarding",
        element: <AdminOnboarding />,
      },
      {
        path: "staff",
        element: <AdminStaff />,
      },
      {
        path: "programs",
        element: <AdminPrograms />,
      },
      {
        path: "social-connect",
        element: <AdminSocialConnect />,
      },
      {
        path: "storage",
        element: <AdminStorage />,
      },
      {
        path: "notifications",
        element: <AdminNotifications />,
      },
      {
        path: "explore-radios",
        element: <AdminExploreRadios />,
      },
      {
        path: "payment-processors",
        element: <AdminPaymentProcessors />,
      },
      {
        path: "additional-charges",
        element: <AdminAdditionalCharges />,
      },
      {
        path: "support",
        element: <AdminSupport />,
      },
      {
        path: "knowledge-base",
        element: <AdminKnowledgeBase />,
      },
      {
        path: "profile",
        element: <AdminProfile />,
      },
    ]
  },
  {
    path: "/program/:programSlug",
    element: <ProgramPage />,
  },
  {
    path: "/sa/dashboard",
    element: <SuperAdminDashboard />,
  },
  {
    path: "/sa/radios",
    element: <SuperAdminRadios />,
  },
  {
    path: "/sa/frequencies",
    element: <SuperAdminFrequencies />,
  },
  {
    path: "/sa/ads",
    element: <Navigate to="/sa/campaigns" replace />,
  },
  {
    path: "/sa/ad-marketplace",
    element: <Navigate to="/sa/marketplace" replace />,
  },
  {
    path: "/sa/revenue-share",
    element: <SARevenueShare />,
  },
  {
    path: "/sa/sponsors",
    element: <SASponsors />,
  },
  {
    path: "/sa/community-center",
    element: <SACommunityCenter />,
  },
  {
    path: "/sa/global-moderation",
    element: <SAGlobalModeration />,
  },
  {
    path: "/sa/ai-radio",
    element: <SAAIRadio />,
  },
  {
    path: "/sa/growth-center",
    element: <Navigate to="/sa/analytics" replace />,
  },
  {
    path: "/sa/radio-analytics",
    element: <SuperAdminRadioAnalytics />,
  },
  {
    path: "/sa/community-analytics",
    element: <SuperAdminCommunityAnalytics />,
  },
  {
    path: "/sa/monetization-analytics",
    element: <SuperAdminRevenueAnalytics />,
  },
  {
    path: "/sa/plans",
    element: <SuperAdminPlans />,
  },
  {
    path: "/sa/analytics",
    element: <SuperAdminAnalytics />,
  },
  {
    path: "/sa/radio-health",
    element: <Navigate to="/sa/radio-analytics" replace />,
  },
  {
    path: "/sa/reports",
    element: <Navigate to="/sa/analytics" replace />,
  },
  {
    path: "/sa/radio-approvals",
    element: <SuperAdminRadioApprovals />,
  },
  {
    path: "/sa/storage",
    element: <SuperAdminStorage />,
  },
  {
    path: "/sa/social-status",
    element: <Navigate to="/sa/system-health-center" replace />,
  },
  {
    path: "/sa/system-health",
    element: <Navigate to="/sa/system-health-center" replace />,
  },
  {
    path: "/sa/billing",
    element: <SuperAdminBilling />,
  },
  {
    path: "/sa/payments",
    element: <SuperAdminPayments />,
  },
  {
    path: "/sa/payouts",
    element: <SAPayouts />,
  },
  {
    path: "/sa/economy",
    element: <Navigate to="/sa/billing" replace />,
  },
  {
    path: "/sa/verification",
    element: <SAVerification />,
  },
  {
    path: "/sa/invoices",
    element: <SuperAdminInvoices />,
  },
  {
    path: "/sa/payment-processors",
    element: <SuperAdminPaymentProcessors />,
  },
  {
    path: "/sa/additional-charges",
    element: <Navigate to="/sa/fees-charges" replace />,
  },
  {
    path: "/sa/marketing",
    element: <SuperAdminMarketing />,
  },
  {
    path: "/sa/broadcast-messages",
    element: <Navigate to="/sa/global-notification-center" replace />,
  },
  {
    path: "/sa/broadcast-center",
    element: <Navigate to="/sa/global-notification-center" replace />,
  },
  {
    path: "/sa/notifications",
    element: <Navigate to="/sa/global-notification-center" replace />,
  },
  {
    path: "/sa/apps",
    element: <SuperAdminApps />,
  },
  {
    path: "/sa/live-support",
    element: <SuperAdminLiveSupport />,
  },
  {
    path: "/sa/ai-assistant",
    element: <SuperAdminAIAssistant />,
  },
  {
    path: "/sa/audit-log",
    element: <Navigate to="/sa/security" replace />,
  },
  {
    path: "/sa/support",
    element: <SuperAdminSupport />,
  },
  {
    path: "/sa/settings",
    element: <SuperAdminSettings />,
  },
  {
    path: "/sa/settings/apps",
    element: <Navigate to="/sa/apps" replace />,
  },
  {
    path: "/sa/email-templates",
    element: <Navigate to="/sa/global-notification-center" replace />,
  },
  {
    path: "/sa/contracts",
    element: <SuperAdminContracts />,
  },
  {
    path: "/sa/legal-templates",
    element: <SuperAdminLegalTemplates />,
  },
  {
    path: "/sa/legal-center",
    element: <SuperAdminLegalCenter />,
  },
  {
    path: "/sa/ad-network",
    element: <Navigate to="/sa/campaigns" replace />,
  },
  {
    path: "/sa/ad-spaces",
    element: <SAAdSpaces />,
  },
  {
    path: "/sa/own-ads",
    element: <SAOwnAds />,
  },
  {
    path: "/sa/rfw-campaigns",
    element: <Navigate to="/sa/campaigns" replace />,
  },
  {
    path: "/sa/radio-advertiser",
    element: <Navigate to="/sa/advertisers" replace />,
  },
  {
    path: "/sa/campaigns",
    element: <SACampaigns />,
  },
  {
    path: "/sa/advertisers",
    element: <SAAdvertisers />,
  },
  {
    path: "/sa/marketplace",
    element: <SAMarketplaceUnified />,
  },
  {
    path: "/sa/commercial-marketplace",
    element: <Navigate to="/sa/marketplace" replace />,
  },
  {
    path: "/sa/monetization-audit",
    element: <Navigate to="/sa/security" replace />,
  },
  {
    path: "/sa/broadcasters",
    element: <SABroadcasters />,
  },
  {
    path: "/sa/programs",
    element: <SAPrograms />,
  },
  {
    path: "/sa/top-fans",
    element: <Navigate to="/sa/community-analytics" replace />,
  },
  {
    path: "/sa/listener-tiers",
    element: <Navigate to="/sa/community-analytics" replace />,
  },
  {
    path: "/sa/listener-map",
    element: <Navigate to="/sa/community-analytics" replace />,
  },
  {
    path: "/sa/live-radios",
    element: <Navigate to="/sa/radio-analytics" replace />,
  },
  {
    path: "/sa/trending",
    element: <Navigate to="/sa/community-analytics" replace />,
  },
  {
    path: "/sa/social-audit",
    element: <Navigate to="/sa/security" replace />,
  },
  {
    path: "/sa/vip-clubs",
    element: <Navigate to="/sa/community-analytics" replace />,
  },
  {
    path: "/sa/users",
    element: <SAUsersManagement />,
  },
  {
    path: "/sa/integrations",
    element: <SAIntegrationsCenter />,
  },
  {
    path: "/sa/feature-flags",
    element: <Navigate to="/sa/settings" replace />,
  },
  {
    path: "/sa/licensing",
    element: <Navigate to="/sa/plans" replace />,
  },
  {
    path: "/sa/global-config",
    element: <Navigate to="/sa/settings" replace />,
  },
  {
    path: "/sa/global-audit-center",
    element: <Navigate to="/sa/security" replace />,
  },
  {
    path: "/sa/system-health-center",
    element: <SASystemHealthCenter />,
  },
  {
    path: "/sa/global-notification-center",
    element: <SAGlobalNotificationCenter />,
  },
  {
    path: "/sa/global-backup-center",
    element: <Navigate to="/sa/maintenance-center" replace />,
  },
  {
    path: "/sa/global-maintenance-center",
    element: <Navigate to="/sa/maintenance-center" replace />,
  },
  {
    path: "/sa/maintenance-center",
    element: <SAMaintenanceCenter />,
  },
  {
    path: "/sa/releases",
    element: <SAReleases />,
  },
  {
    path: "/sa/roles-permissions",
    element: <SARolesPermissions />,
  },
  {
    path: "/sa/security",
    element: <SASecurityCenter />,
  },
  {
    path: "/legal-center",
    element: <LegalCenterPage />,
  },
  {
    path: "/sa/platform-fees",
    element: <Navigate to="/sa/fees-charges" replace />,
  },
  {
    path: "/sa/annual-license",
    element: <Navigate to="/sa/plans" replace />,
  },
  {
    path: "/sa/billing-renewals",
    element: <Navigate to="/sa/plans" replace />,
  },
  {
    path: "/sa/billing/renewals",
    element: <Navigate to="/sa/plans" replace />,
  },
  {
    path: "/sa/fees-charges",
    element: <SAFeesCharges />,
  },
  {
    path: "/sa/radios/:id/qr",
    element: <SARadioQrPage />,
  },
  {
    path: "/sa/radios/:id/domain",
    element: <SARadioDomainPage />,
  },
  {
    path: "/sa/premium-domains",
    element: <SuperAdminPremiumDomains />,
  },
  {
    path: "/sa/permanent-qr",
    element: <SAPermanentQr />,
  },
  {
    path: "/sign/contract/:token",
    element: <PublicSignContract />,
  },
  {
    path: "/app/chat",
    element: <AppChatPage />,
  },
  {
    path: "/app/siguiendo",
    element: <AppSiguiendoPage />,
  },
  {
    path: "/app/saludos-canciones",
    element: <SaludosCancionesPage />,
  },
  {
    path: "/app/notificaciones",
    element: <AppNotificacionesPage />,
  },
  {
    path: "/app/trending",
    element: <AppTrendingPage />,
  },
  {
    path: "/app/live",
    element: <AppLivePage />,
  },
  {
    path: "/app/search",
    element: <AppSearchPage />,
  },
  {
    path: "/app/profile",
    element: <AppProfilePage />,
  },
  {
    path: "/app/favorites",
    element: <AppFavoritesPage />,
  },
  {
    path: "/app",
    element: <AppPage />,
  },
  {
    path: "/tv-app/player/:radioId",
    element: <TvPlayerPage />,
  },
  {
    path: "/tv-app/video/:videoId",
    element: <TvVideoPage />,
  },
  {
    path: "/tv-app/podcast/:podcastId",
    element: <TvPodcastPage />,
  },
  {
    path: "/tv-app/qr",
    element: <TvPairingProvider><TvQrPage /></TvPairingProvider>,
  },
  {
    path: "/tv-app/remote",
    element: <TvPairingProvider><TvRemotePage /></TvPairingProvider>,
  },
  {
    path: "/tv-app",
    element: <TvPairingProvider><TvAppPage /></TvPairingProvider>,
  },
  {
    path: "/tv-app/radio/:radioId",
    element: <TvRadioProfilePage />,
  },
  {
    path: "/tv-app/program/:programSlug",
    element: <TvProgramDetailPage />,
  },
  {
    path: "/tv-app/host/:hostId",
    element: <TvHostDetailPage />,
  },
  {
    path: "/tv-app/event/:eventId",
    element: <TvEventDetailPage />,
  },
  {
    path: "/tv-app/contest/:contestId",
    element: <TvContestDetailPage />,
  },
  {
    path: "/app/player/:slug",
    element: <ChannelPlayerPage />,
  },
  {
    path: "/business/player/:slug",
    element: <ChannelPlayerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;